import styled, { keyframes } from 'styled-components/macro'

import { Overlay, styleReset } from 'styles/misc'
import { mq } from 'styles/mq'
import GoldenBg from 'assets/golden-bg.webp'

export const ActiveArea = styled.button`
  --height: 13.2%;
  --size: 2.5rem;
  --offset: 0;
  --row: 1;

  ${mq.medium} {
    --height: 27.5%;
  }

  ${styleReset}
  position: absolute;
  top: calc((var(--row) - 1) * var(--height));
  height: var(--height);
  margin-top: var(--offset);
  cursor: pointer;
`

const dotAnimation = keyframes`
  from { transform: scale(0.9); }
  15%  { transform: scale(0.6); }
  30%  { transform: scale(1); }
  40% { transform: scale(0.8); }
  50% { transform: scale(0.9); }
  100% { transform: scale(0.9); }
`

export const Dot = styled.span`
  display: block;
  position: absolute;
  bottom: 25%;
  left: 50%;
  width: var(--size);
  margin: calc(-1 * var(--size) / 2);
  aspect-ratio: 1;
  animation: 2s ${dotAnimation} ease-in-out infinite;

  &::before,
  &::after {
    content: '';
    ${Overlay}
    border-radius: 50%;
    opacity: 0.75;
    background-color: var(--theme-color);
  }

  &::after {
    opacity: 0;
    transition: 0.5s opacity;
    background: url('${GoldenBg}') center center / 70rem auto no-repeat;
  }

  ${ActiveArea}:hover & {
    animation-play-state: paused;

    &::after {
      opacity: 1;
    }
  }
`
